// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__p5rYq"};